import * as actionTypes from "Redux/Actions/actionTypes";

const doCheckExistingUser = (userdata, callback = () => {}) => ({
  type: actionTypes.EXISTINGUSER_REQUEST,
  data: userdata,
  callback,
});

export default doCheckExistingUser;
